var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ArticleLayout',{attrs:{"color":"#98cab2","title":"售后小贴士","data":_vm.textData}})}
var staticRenderFns = []

export { render, staticRenderFns }